"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductSearchResponse = ProductSearchResponse;
//# sourceMappingURL=product-search.response.js.map